<button class="btn btn-sm btn-dark mr-1" (click)="exportAgGridToCSV()" [disabled]="generatingCsv">
  <span *ngIf="!generatingCsv; else loading" translate>
    <i class="material-icons md-18 md-btn-align">description</i> LIST_VIEW.CSV_EXPORT.CSV_EXPORT
  </span>
</button>

<ng-template #loading>
  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  {{ 'LIST_VIEW.CSV_EXPORT.WIRD_ERZEUGT' | translate }}
</ng-template>
